import React from "react"
import { BillingForm } from "./billing-form"

export function BillingUpdate() {
  return <BillingForm />
}

BillingUpdate.propTypes = {}
BillingUpdate.defaultProps = {}
